import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { FullAutoImportService, ImportFullAutoDto } from "@sharedcommon/rest/data.restservice";
import { UserService } from "@sharedcommon/services/user.service";
import { Constants } from "@sharedcommon/util/constants.util";


@Component({
  selector: 'rawmaterials-import-full-auto-popin',
  templateUrl: './rawmaterials-import-full-auto-popin.component.html',
  styleUrls: [ './rawmaterials-import-full-auto-popin.component.scss' ]
})
export class RawmaterialsImportFullAutoPopin {
  listFormat: any[];
  selectedFormat: string = null ;
  /* User this to show the message in case of no selected format */
  NO_FORMAT = 'label.user.rawmaterial.import.no-format' ;
  fileName: string ;
  fileContent: string ;

  showError: boolean ;
  isValidFile: boolean ;
  fileErrorMessage: string ;

  title: string;

  creationMode: boolean;

  constructor(
    private readonly translateService: TranslateService,
    private readonly userService: UserService,
    private readonly fullAutoImportService: FullAutoImportService,
    private readonly dialogRef: MatDialogRef<RawmaterialsImportFullAutoPopin>,
    @Inject(MAT_DIALOG_DATA) private readonly data: {
      creationMode: boolean
    }
  ) {
  }

  ngOnInit(): void {
    this.selectedFormat = this.NO_FORMAT ;
    this.listFormat = [ this.NO_FORMAT, ...this.userService.getEntityDto().rawmatExportList.split(";") ] ;
    this.creationMode = this.data.creationMode;
    const titleKey: string = this.creationMode ? 'label.user.rawmaterial.popin.import.full-auto.creation' : 'label.user.rawmaterial.popin.import.full-auto.modification';
    this.title = this.translateService.instant(titleKey);
  }

  onFileSelection(event: any): void {
    this.showError = true ;
    const file:File = event.target.files[0];
    this.readFileContent(file) ;
  }

  readFileContent(file: File): void {
    if (!file) {
      this.isValidFile = false ;
      this.fileName = null ;
      this.fileContent = null ;
      return ;
    }
    this.fileName = file.name ;
    const reader = new FileReader() ;
    reader.onload = () => {
      this.fileContent = reader.result as string ;
      this.updateValidFile() ;
    };
    reader.readAsText(file);
  }

  updateValidFile(): void {
    const requiredError = !this.fileName ;
    const extensionError: boolean = this.fileName && !this.fileName.toLocaleLowerCase().endsWith(".csv") ;
    const numberImportError: boolean = (this.fileContent.split("\r\n").filter(r => r != '').length - 1) > this.userService.getEntityDto().limitImport;
    this.isValidFile = !requiredError && !extensionError && !numberImportError;
    if (this.isValidFile) {
      this.fileErrorMessage = '' ;
      return ;
    }
    if (extensionError) {
      this.fileErrorMessage = this.translateService.instant("msg.user.rawmaterial.import.extension-error") ;
    } else if (requiredError) {
      this.fileErrorMessage = this.translateService.instant("msg.user.rawmaterial.import.required-file-error") ;
    } else if (numberImportError) {
      this.fileErrorMessage = this.translateService.instant('label.user.export.error.limit-import', {param: this.userService.getEntityDto().limitImport});
    }
  }

  launchImport(): void {
    this.showError = true ;
    this.updateValidFile() ;
    if (!this.isValidFile) {
      return ;
    }
    const realRelectedFormat = this.selectedFormat === this.NO_FORMAT ? null : this.selectedFormat ;
    const importDto: ImportFullAutoDto = {
      format: realRelectedFormat,
      csvFileName: this.fileName,
      csvContent: this.fileContent
    };
    const entityCode = this.userService.getEntityDto().code;
    if (this.creationMode) {
      this.fullAutoImportService.importRmFeedFullAutoCreation(entityCode, importDto).subscribe((response)=> {
        this.userService.addJob(response, Constants.JOB_TYPE_IMPORT_RM_FULL_AUTO);
      });
    } else {
      this.fullAutoImportService.importRmFeedFullAutoModification(entityCode, importDto).subscribe((response)=> {
        this.userService.addJob(response, Constants.JOB_TYPE_IMPORT_RM_FULL_AUTO);
      });
    }
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}
